var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7162 14.0442L18.848 14.0435C18.2356 14.0435 17.7392 14.5398 17.7392 15.1522V19.5825C17.7392 20.1948 18.2356 20.6913 18.8479 20.6913H26.6577C25.8025 22.9106 24.2063 24.7693 22.1699 25.9502L25.5 31.7149C30.8418 28.6255 34 23.2048 34 17.1367C34 16.2727 33.9363 15.6551 33.8089 14.9596C33.7121 14.4312 33.2534 14.0442 32.7162 14.0442Z",
    fill: "#167EE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 27.3478C13.1781 27.3478 9.84154 25.2596 8.04957 22.1695L2.28511 25.4921C5.21861 30.5763 10.714 34 17 34C20.0837 34 22.9934 33.1697 25.5 31.7228V31.7149L22.1699 25.9502C20.6467 26.8336 18.884 27.3478 17 27.3478Z",
    fill: "#12B347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 31.7228V31.7149L22.1699 25.9502C20.6467 26.8336 18.8841 27.3478 17 27.3478V34C20.0837 34 22.9936 33.1697 25.5 31.7228Z",
    fill: "#0F993E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65218 17C6.65218 15.1161 7.1663 13.3536 8.04957 11.8305L2.28511 8.5079C0.830211 11.0066 0 13.9084 0 17C0 20.0916 0.830211 22.9934 2.28511 25.4921L8.04957 22.1695C7.1663 20.6464 6.65218 18.8839 6.65218 17Z",
    fill: "#FFD500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 6.65218C19.4923 6.65218 21.7816 7.53777 23.5697 9.01086C24.0108 9.37424 24.652 9.34801 25.0561 8.94393L28.1951 5.8049C28.6536 5.34643 28.6209 4.59598 28.1312 4.17111C25.1352 1.57204 21.2372 0 17 0C10.714 0 5.21861 3.42371 2.28511 8.5079L8.04957 11.8305C9.84154 8.74039 13.1781 6.65218 17 6.65218Z",
    fill: "#FF4B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5697 9.01086C24.0108 9.37424 24.6521 9.34801 25.0561 8.94393L28.1951 5.8049C28.6535 5.34643 28.6208 4.59598 28.1312 4.17111C25.1352 1.57197 21.2372 0 17 0V6.65218C19.4922 6.65218 21.7816 7.53777 23.5697 9.01086Z",
    fill: "#D93F21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google_logo.5a9be44968a5e13061c50d66f4c59c38.svg";
export { ForwardRef as ReactComponent };